export default __webpack_public_path__ + "static/media/invoice_3.2fe0debd.PNG";